// Brochure text shared by the HTML layout; artwork comes from the front and back PSD originals.
export const zh = {
  about: "关于 OpenGA",
  title: "时空智能体共享服务平台",
  tagline: "打造时空智能基础设施，让时空智能触手可及",
  tryNow: "立刻体验",
  download: "下载宣传册",
  overview: "平台简介",
  intro: [
    "时空智能体共享服务平台（Open Geospatial Agent，OpenGA）是武汉大学龚健雅院士团队研发的自主可控时空智能体基础设施，于2026年10月正式发布。",
    "OpenGA面向“数字地球”时空信息智能服务需求，突破时空智能体构建与服务技术，提出时空技能模型，研制时空智能体引擎与共享服务平台，建立全球时空智能体引接汇聚的开放时空智能体服务体系，实现自然语言驱动数字地球复杂遥感与时空分析业务。",
    "平台接入开放时空智能社区（OGE Alliance），基于中国版数字地球引擎OGE，以统一的GeoMCP协议和GeoSkill技能规范，兼容全球时空信息标准，实现工具、模型、技能与智能体的互操作，形成可接入智慧城市、自然资源、能源等业务系统的“时空智能基础设施”，推动数字地球引擎向地球智能引擎发展。",
  ],
  stats: [
    ["200万+", "景卫星数据"],
    ["700+", "时空算子"],
    ["150+", "平台技能"],
  ],
  featuresTitle: "平台特色",
  features: [
    [
      "时空数据智能体",
      "海量时空数据的高效检索增强技术",
      "集成全球矢量数据、数字高程模型（DEM）、对地观测影像、定量遥感产品和气象数据产品，支持第三方、本地与用户私有数据接入。依托基础设施的数据就绪能力，对数据进行预处理、清洗和标准化，形成分析就绪数据（ARD）；通过向量语义知识库与知识图谱，实现PB级海量时空数据快速接入与检索调度，涵盖“武汉一号”、全球定量遥感产品等超200万景卫星数据。",
      4,
    ],
    [
      "时空计算智能体",
      "时空算子统一能力表达 GeoSkill",
      "针对多源时空算子与工具描述不统一、工作流难以跨平台复用等瓶颈，提出GeoSkill技能规范，适配坐标参考系统、投影方式和存储数据格式，统一描述工具名称、参数、依赖、调用链与输出约束。兼容OGE、QGIS、国产卫星数据及MCP外部工具，缩短第三方算法封装周期，实现700余算子时空能力的精准发现与匹配。",
      5,
    ],
    [
      "时空推理智能体",
      "垂域大模型跨域 GeoMCP 接入方法",
      "依托发表于IJGIS的GeoMCP理论，将武汉大学20亿级参数多模态遥感视觉大模型、水文大模型和变化检测大模型等，通过时空信息能力映射转为可互操作的ISO/OGC API。评测与消融实验表明，GeoMCP服务器抽象和多智能体设计相较于基线方法能够提升系统性能。",
      6,
    ],
    [
      "开放时空智能体",
      "可扩展、开放的时空智能体接入与调度",
      "以开放时空信息基础设施为底座，以智能体引擎支持任务理解、知识检索、规划与调度和可信溯源，以开放应用平台为入口，封装、集成、编排其他智能体能力。将时空问题转化为可理解、可规划、可执行、可反馈和可追溯的任务流程，推动OpenGA从“单系统能力”走向“开放能力生态”。",
      7,
    ],
  ],
  architectureTitle: "平台总览",
  architectureLabel: "一个引擎 · 一个平台 · 一套规范 · 三个库",
  architecture:
    "OpenGA以开放时空信息基础设施为底座，以智能引擎组织能力，以开放架构连接资源，以标准规范统一调用，构建可扩展、可协同、可演化的时空智能体体系。",
  librariesTitle: "平台能力库",
  libraries:
    "构建工具库、知识库、技能库三大能力库，形成面向智能体就绪基础设施的重要组成部分，为智能体提供稳定的时空能力支撑。",
  libraryNames: ["工具库", "知识库", "技能库"],
  engineTitle: "平台引擎",
  engine:
    "OpenGA的任务运行与流程控制中枢，面向地理信息复杂任务，以统一状态驱动意图理解、知识检索、规划执行与反思聚合的全链路图流转，并将经验沉淀为可复用的方案资产，形成“自主求解—动态反馈—可信溯源—持续自进化”的完整闭环。",
  steps: [
    ["意图理解", "用户任务、多轮对话、任务意图与实体约束"],
    ["知识检索", "向量匹配资源集合、排序得分结果、知识图谱检索与用户方案确认"],
    ["规划与反思", "服务链编排、工作流执行、中间结果与反思重规划"],
    ["知识沉淀与自进化", "全过程溯源、知识增量更新与持续学习"],
  ],
  skillsTitle: "平台技能",
  skills:
    "以GeoSkill开放社区构建开发者生态，通过GeoSkill Hub提供开放服务能力，提供水体提取、变化监测等150余种技能，同时支持外部能力的统一注册、开放共享与互操作。",
  skillNames: [
    "地理知识问答",
    "遥感AI · 变化检测",
    "资源检索发现",
    "气象灾害预警",
    "通用栅格计算",
    "通用矢量计算",
    "水文分析与水情预测",
    "生态修复成效评估",
    "DEM地形因子分析",
    "遥感AI · 目标提取",
  ],
  skillsLink: "探索开放技能中心",
  servicesTitle: "平台服务",
  services:
    "以新一代OGC API为核心接口，全面推进ISO时空服务架构与ISO GeoAI标准体系建设，以ISO/OGC国际首个时空智能标准为起点，推动全球时空智能体服务体系建设。",
  applicationsTitle: "应用与服务",
  scenariosLabel: "典型场景",
  valueLabel: "应用价值",
  applications: [
    [
      "自然资源",
      "资源变化，对话即知",
      "基于变化检测大模型构建，以自然语言交互提升业务生产效率。",
      "耕地变化检测、重点地物分类、城市违建监测等。",
      "减少人工操作与系统切换，提升监测效率与业务响应速度。",
      22,
    ],
    [
      "生态环境",
      "生态监测，智能洞察",
      "改变传统人工交互模式，降低复杂场景生态遥感监测难度。",
      "生态本底分析、矿区地物图斑提取、生态修复成效评估。",
      "让生态监测更易用、更及时、更智能。",
      26,
    ],
    [
      "能源运输安全",
      "能源保供，时空护航",
      "面向能源运输通道气象灾害预警与应急需求，融合地图、气象、遥感、北斗终端数据，智能研判灾害风险区域。",
      "作业安全预警、桥涵水害分析、汇水区风险点识别、暴雨洪涝应急等。",
      "提升监测与预警效率，为能源安全提供时空智能保障。",
      23,
    ],
    [
      "低空经济",
      "低空业务，一语直达",
      "基于低空数字底座，融合低空时空数据与智能体能力，提升无人机作业效率。",
      "无人机巡检、低空监管、施工安全监察、交通治理等。",
      "降低平台操作门槛，提升无人机作业效率与低空监管效能。",
      24,
    ],
  ],
  contactTitle: "合作与联系",
  cooperation: "合作联系：乐老师",
  support: "技术支持QQ群：1009665391",
  address: "湖北省武汉市洪山区珞喻路129号",
  follow: "扫码关注 OGE Alliance 微信公众号",
};

export const en = {
  about: "About OpenGA",
  title: "Open Geospatial Agent",
  tagline:
    "Building geospatial intelligence infrastructure, making spatial intelligence accessible",
  tryNow: "Try OpenGA",
  download: "Download brochure",
  overview: "Platform introduction",
  intro: [
    "Open Geospatial Agent (OpenGA) is independently developed and controllable geospatial agent infrastructure created by Academician Gong Jianya’s team at Wuhan University. It was officially released in October 2026.",
    "Addressing Digital Earth’s demand for intelligent geospatial information services, OpenGA advances agent construction and service technologies, introduces a geospatial skill model, and develops an agent engine and shared service platform. It connects geospatial agents worldwide to enable natural language to drive complex remote sensing and geospatial analysis workflows.",
    "Connected to the OGE Alliance and built on the Open Geospatial Engine (OGE), OpenGA uses the GeoMCP protocol and GeoSkill specification to interoperate across tools, models, skills, and agents. Compatible with international geospatial standards, it provides infrastructure for smart cities, natural resources, energy, and other business systems, advancing the Digital Earth engine toward an intelligent Earth engine.",
  ],
  stats: [
    ["2M+", "Satellite scenes"],
    ["700+", "Geospatial operators"],
    ["150+", "Platform skills"],
  ],
  featuresTitle: "Platform capabilities",
  features: [
    [
      "Geospatial data agents",
      "Retrieval augmentation for massive geospatial datasets",
      "Integrates global vectors, DEMs, Earth observation imagery, quantitative remote sensing products, and weather products, with support for third-party, local, and private data. Preprocessing, cleaning, and standardization produce Analysis Ready Data (ARD). Semantic vector and knowledge graph retrieval enable fast access and scheduling across petabyte-scale data, including over two million satellite scenes such as Wuhan-1 and global quantitative remote sensing products.",
      4,
    ],
    [
      "Geospatial computing agents",
      "Unified operator capabilities with GeoSkill",
      "GeoSkill addresses inconsistent tool descriptions and workflows that cannot be reused across platforms. It adapts coordinate systems, projections, and storage formats, and describes names, parameters, dependencies, call chains, and output constraints. Supporting OGE, QGIS, Chinese satellite data, and external MCP tools, it shortens algorithm integration and precisely discovers and matches more than 700 operators.",
      5,
    ],
    [
      "Geospatial reasoning agents",
      "Cross-domain specialist models through GeoMCP",
      "Based on GeoMCP research published in IJGIS, geospatial capability mapping exposes Wuhan University’s two-billion-parameter multimodal remote sensing vision model, hydrological models, and change detection models as interoperable ISO/OGC APIs. Evaluations and ablation studies show that GeoMCP server abstractions and multi-agent designs improve performance over baseline methods.",
      6,
    ],
    [
      "Open geospatial agents",
      "Extensible agent integration and orchestration",
      "Built on open geospatial infrastructure, the agent engine supports task understanding, knowledge retrieval, planning, scheduling, and trusted provenance. The application platform encapsulates, integrates, and orchestrates other agents, turning geospatial questions into understandable, plannable, executable, traceable workflows with feedback, moving from a single system toward an open capability ecosystem.",
      7,
    ],
  ],
  architectureTitle: "Platform overview",
  architectureLabel: "One engine · One platform · One specification · Three libraries",
  architecture:
    "OpenGA builds on open geospatial infrastructure, organizes capabilities through an intelligent engine, connects resources through an open architecture, and unifies invocation through standards, creating an extensible, collaborative, and evolving agent ecosystem.",
  librariesTitle: "Capability libraries",
  libraries:
    "Tool, knowledge, and skill libraries form a key part of agent-ready infrastructure, providing stable geospatial capabilities for agents.",
  libraryNames: ["Tools", "Knowledge", "Skills"],
  engineTitle: "Agent engine",
  engine:
    "The engine controls task execution and workflows for complex geographic information tasks. A unified state drives intent understanding, knowledge retrieval, planning, execution, reflection, and aggregation. Experience becomes reusable solution assets in a continuous loop of autonomous problem solving, dynamic feedback, trusted provenance, and ongoing improvement.",
  steps: [
    ["Understand intent", "Tasks, dialogue, intent, entities, and constraints"],
    [
      "Retrieve knowledge",
      "Vector-matched resources, ranked results, knowledge graph retrieval, and plan confirmation",
    ],
    [
      "Plan and reflect",
      "Service chains, workflow execution, intermediate results, and replanning",
    ],
    [
      "Learn and evolve",
      "End-to-end provenance, incremental knowledge updates, and continuous learning",
    ],
  ],
  skillsTitle: "Platform skills",
  skills:
    "The open GeoSkill community supports a developer ecosystem. GeoSkill Hub offers more than 150 skills, including water extraction and change monitoring, alongside unified registration, open sharing, and interoperability for external capabilities.",
  skillNames: [
    "Geographic Q&A",
    "Remote sensing AI · Change detection",
    "Resource discovery",
    "Weather hazard warnings",
    "Raster computation",
    "Vector computation",
    "Hydrological analysis and forecasting",
    "Ecological restoration assessment",
    "DEM terrain analysis",
    "Remote sensing AI · Object extraction",
  ],
  skillsLink: "Explore the Open Skill Hub",
  servicesTitle: "Platform services",
  services:
    "With next-generation OGC APIs as its core interfaces, OpenGA advances the ISO geospatial service architecture and ISO GeoAI standards. Starting with the first ISO/OGC international geospatial intelligence standard, it supports the development of a global geospatial agent service ecosystem.",
  applicationsTitle: "Applications and services",
  scenariosLabel: "Typical scenarios",
  valueLabel: "Application value",
  applications: [
    [
      "Natural resources",
      "Discover resource changes through conversation",
      "Change detection models and natural language interaction improve operational efficiency.",
      "Cropland change detection, key land feature classification, and unauthorized construction monitoring.",
      "Less manual work and system switching, with faster monitoring and response.",
      22,
    ],
    [
      "Ecology and environment",
      "Intelligent insights for ecological monitoring",
      "Transforms manual interaction to simplify remote sensing monitoring in complex ecological settings.",
      "Ecological baseline analysis, mine land feature extraction, and restoration assessment.",
      "More accessible, timely, and intelligent ecological monitoring.",
      26,
    ],
    [
      "Energy transport safety",
      "Geospatial intelligence for reliable energy supply",
      "Combines maps, weather, remote sensing, and BeiDou terminal data to assess weather-related hazards and emergency risks along energy transport corridors.",
      "Operational warnings, bridge and culvert flood analysis, catchment risk identification, and storm and flood response.",
      "More efficient monitoring and warnings to support energy security.",
      23,
    ],
    [
      "Low-altitude economy",
      "Direct access to low-altitude operations",
      "Integrates low-altitude geospatial data and agent capabilities on a digital foundation to improve drone operations.",
      "Drone inspections, airspace supervision, construction safety inspections, and traffic management.",
      "Easier platform operation and more efficient drone missions and supervision.",
      24,
    ],
  ],
  contactTitle: "Cooperation and contact",
  cooperation: "Cooperation: Teacher Le",
  support: "Technical support QQ group: 1009665391",
  address: "129 Luoyu Road, Hongshan District, Wuhan, Hubei, China",
  follow: "Follow OGE Alliance on WeChat",
};
